var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bigloader"},[_c('v-progress-circular',{staticClass:"centered",attrs:{"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }